<template>
  <form class="form form-register-details" @submit.prevent="postRegister">

    <timeline labels="Numer telefonu, Kod SMS, Twoje dane" current="3"></timeline>

    <slide-y-up-transition :duration="500" :delay="200">
      <div v-show="show" class="box-info text-center">Uzupełnij swoje dane.</div>
    </slide-y-up-transition>

    <slide-x-left-transition :duration="400" :delay="200">
      <div class="form-group" v-show="show">
        <label>Imię</label>
        <div class="input-wrapper">
          <input v-model="form.first_name"
                 type="text"
                 :class="{'input-error' : errors.first_name }"
                 placeholder="Podaj swoje imię"
                 ref="firstNameInput"
                 required/>
        </div>
        <p class="error" v-if="errors.first_name">{{ errors.first_name[0] }}</p>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="500" :delay="300">
      <div class="form-group" v-show="show">
        <label>Nazwisko</label>
        <div class="input-wrapper">
          <input v-model="form.last_name"
                 type="text"
                 :class="{'input-error' : errors.last_name }"
                 placeholder="Podaj swoje nazwisko"
                 required/>
        </div>
        <p class="error" v-if="errors.last_name">{{ errors.last_name[0] }}</p>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="500" :delay="400">
      <div class="form-group" v-show="show">
        <label>Twoja rola</label>
        <div class="select-wrapper">
          <span v-if="form.role_slug === null" class="select-placeholder">Wybierz rolę</span>
          <select v-model="form.role_slug" required>
            <option v-for="item in roles" :value="item.slug">{{ item.name }}</option>
          </select>
        </div>
        <p class="error" v-if="errors.role_slug">{{ errors.role_slug[0] }}</p>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="400">
      <div class="form-group" v-show="form.role_slug === 'ph-kp' || form.role_slug === 'asm'">
        <label>Numer pracowniczy</label>
        <div class="input-wrapper">
          <input v-model="form.sap_id"
                 type="number"
                 :class="{'input-error' : errors.sap_id }"
                 placeholder="Podaj swój numer pracowniczy"
                 autocomplete="off"
                 spellcheck="false"/>
        </div>
        <p class="error" v-if="errors.sap_id">{{ errors.sap_id[0] }}</p>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="600" :delay="500">
      <div class="form-group" v-show="show">
        <label>Data urodzenia</label>
        <div class="input-wrapper">
          <input v-model="form.birthday"
                 type="date"
                 :class="{'input-error' : errors.birthday }"
                 placeholder="Podaj swoją datę urodzenia"
                 required/>
        </div>
        <p class="error" v-if="errors.birthday">{{ errors.birthday[0] }}</p>
        <p class="text-small text-gray-light">Aplikacja zawiera materiały dotyczące napojów alkoholowych przeznaczone
          wy­łącz­nie dla osób dorosłych powyżej 18 roku życia, w związku z czym nie należy ich udostępniać osobom
          poniżej 18 roku życia.</p>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="700" :delay="600">
      <div class="form-group" v-show="show">
        <label>Hasło do logowania</label>
        <div class="input-wrapper">
          <input v-model="form.password"
                 type="password"
                 :class="{'input-error' : errors.password }"
                 placeholder="Podaj hasło"
                 required/>
        </div>
        <p class="error" v-if="errors.password">{{ errors.password[0] }}</p>
        <p class="text-small text-gray-light">Hasło powinno zawierać: jedną wielką literę, jedną małą literę, jedną
          cyfrę lub znak specjalny i min. 8 znaków.</p>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="800" :delay="700">
      <div class="form-group" v-show="show">
        <label>Powtórz hasło</label>
        <div class="input-wrapper">
          <input v-model="form.password_confirmation"
                 type="password"
                 :class="{'input-error' : errors.password_confirmation }"
                 placeholder="Podaj ponownie hasło"
                 required/>
        </div>
        <p class="error" v-if="errors.password_confirmation">{{ errors.password_confirmation[0] }}</p>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="900" :delay="800">
      <div class="form-group" v-show="show">
        <template v-for="(item,index) in register_agreements">
          <div class="input-wrapper">
            <!--v-model not working - value is passed as props 'checked'-->
            <ion-checkbox mode="md"
                          :checked="tempAgreements.length > 0 ? tempAgreements[index].isChecked : false"
                          @input="checked = target.value"
                          @ionChange="handleCheckbox($event, index, item.key, $event.target.value)">
            </ion-checkbox>
            <label class="checkbox-label">
              <i class="checkbox-caret" v-if="item.required">*</i>
              <div v-html="item.value"></div>
            </label>
          </div>
          <p class="error"
             v-if="errors['agreements.register.'+ item.key]"
             v-text="errors['agreements.register.'+ item.key][0]">
          </p>
        </template>
      </div>
    </slide-x-left-transition>

    <ion-button mode="ios" expand="block" type="submit" :disabled="loading">
      <span v-if="loading"><span class="loader"></span></span>
      <span v-else>Zarejestruj się</span>
    </ion-button>
  </form>
</template>

<script>
  import {unset, cloneDeep} from 'lodash';
  import Timeline from '@/components/Timeline.vue';
  import {mapState} from 'vuex';

  export default {
    name: 'FormRegisterDetails',
    components: {Timeline},
    computed: {
      ...mapState({
        loading: state => state.register.loading,
        errors: state => state.register.errors,
        roles: state => state.global.roles,
        register_agreements: state => state.global.agreements.register,
      })
    },
    data() {
      return {
        show: false,
        form: {
          first_name: '',
          last_name: '',
          birthday: '',
          password: '',
          password_confirmation: '',
          role_slug: null,
          sap_id: '',
          agreements: {
            register: {}  // dynamic (group name requested 6319#note-2)
          }
        },
        tempAgreements: [] // helper
      }
    },
    mounted() {
      this.show = true;
      setTimeout(() => {
        this.$refs.firstNameInput.focus();
      }, 1000)
      // copy global agreements to local halper and unbind two-way
      this.tempAgreements = _.cloneDeep(this.register_agreements)
      // set all agreements to false (requested)
      this.tempAgreements.forEach((item) => {
        let obj = { [item.key]: false }
        Object.assign(this.form.agreements.register, obj)
      })
    },
    methods: {
      handleCheckbox(event, i, key, value) {
        const checkbox = event.target
        // prepare agreements
        let obj = {
          [key]: value == "on" ? true : false
        }
        // checkbox is set true
        if (checkbox.checked) {
          this.tempAgreements[i].isChecked = true
          Object.assign(this.form.agreements.register, obj)
        }
        // checkbox is set false
        else {
          this.tempAgreements[i].isChecked = false
          // Object.assign(this.form.agreements.register, obj)
          this.$set(this.form.agreements.register, key, false)
        }
      },
      postRegister() {
        this.$store.dispatch('DETAILS_REQUEST', this.form).then(() => {
          this.$router.push({name: 'Dashboard'})
          this.$store.dispatch('GLOBAL_TOAST', 'Zarejestrowano poprawnie.');
        })
      }
    }
  }
</script>